import React from 'react';
import {IconButton} from '../Button';
import VisibilityIconButton from './VisibilityIconButton';
import VisibilityHoverIconButton from './VisibilityHoverIconButton';
import VisibilityOffIconButton from './VisibilityOffIconButton';
import VisibilityOffHoverIconButton from './VisibilityOffHoverIconButton';

interface VisibilitySwitcherProps {
  visible?: boolean;
  onClick?: React.MouseEventHandler;
}

export const VisibilitySwitcher = (props: VisibilitySwitcherProps) => {
  const handleMouseDownPassword = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
  };

  return (
    <IconButton
      className="visibility-switcher"
      aria-label="toggle password visibility"
      onClick={props.onClick}
      onMouseDown={handleMouseDownPassword}
      edge="end"
      size="large"
    >
      {props.visible ? (
        <VisibilityIconButton className="visibility-switcher__icon" />
      ) : (
          <VisibilityOffIconButton className="visibility-switcher__icon" />
      )}
      {props.visible ? (
        <VisibilityHoverIconButton className="visibility-switcher__icon--hover" />
      ) : (
          <VisibilityOffHoverIconButton className="visibility-switcher__icon--hover" />
      )}
    </IconButton>
  );
};

export default VisibilitySwitcher;
